module.exports = __webpack_public_path__ + "static/media/siddhi.05ecb54a.jpg";